import { h, render, Component } from 'preact';
import Menu from 'q-mdc/elements/material-menu';
import { Account } from '../icons/headerIcons';
import { getEventTrackGA } from '../../helpers/ga';

import styles from './index.scss';

const defaultLoggedOutMenuArr = [
	// { title: 'My Cart', href: '/QuikrX/Cart',gaEventName: 'cart' },
	// { title: 'My Doorstep Offers', href: '/Escrow/MyOffers/getBuyersOfferForm',gaEventName:'doorstep_offers' },
	// { title: 'My Notifications', href: "no_redicetion" , gaEventName:'notifictions', onClick: (e) => { e.preventDefault(); e.stopPropagation(); }, callFunction:'openNotificationPopup'},
	{ title: 'Chats', href: '/MyQuikr?action=mychats',gaEventName:'chats' },
	{
		href: "/instant-leads",
		title: "Get Instant Leads",
		gaEventName: "instant_leads"
	},
	{ title: 'Login/Register', href: '/SignIn', gaEventName: 'login', onClick: (e) => { e.preventDefault(); e.stopPropagation(); window.location = `/SignIn?redirect=${encodeURIComponent(window.location.href)}`; } }
];

const defaultLoggedInMenuArr = [
	{ href: '/MyQuikr',title: 'My Account',gaEventName: 'account' },
	{ href: '/MyQuikr?action=mychats', title: 'Chats'/*<span class="notification--num" >3</span>*/, gaEventName: 'chats' },
	{ href: '/MyQuikr?action=alertsdetails',title: 'Alerts',gaEventName:'alerts' },
	{ href: '/MyQuikr?action=activeads',title: 'My Ads',gaEventName: 'ads' },
	// { title: 'My Cart', href: '/QuikrX/Cart',gaEventName: 'cart' },
	// { title: 'My Doorstep Offers', href: '/Escrow/MyOffers/getBuyersOfferForm', gaEventName:'doorstep_offers' },
	// { title: 'My Notifications', href: "no_redicetion", gaEventName:'notifictions', onClick: (e) => { e.preventDefault(); e.stopPropagation(); }, callFunction:'openNotificationPopup' },
	{ href: '/MyQuikr?action=lead', title: 'My Leads', gaEventName: 'leads' },
	{
		href: "/instant-leads",
		title: "Instant Leads",
		gaEventName: "instant_leads"
	},
	{ href: '/QuikrX/myorders',title: 'My Orders',gaEventName:'orders' },

	/* <Menu.Item link href="#">Recommendation for me</Menu.Item> */
	
	{ title: 'Logout', href: '/bye',gaEventName:'logout' }
];


class QMenu extends Component {

	pushGAEvent = (eventName) => {
		const { pageType } = this.context;
		const gaEventObject =  { category: 'quikr_pwa',action: `quikr_pwa_${pageType}_usersection`,label: `quikr_pwa_${pageType}_usersection_my_${eventName}` };
		getEventTrackGA(gaEventObject);
	}

	render ( { list, refFn, callHeaderfunction } ) {
		return (
			<Menu
				ref={menu => refFn(menu)}
				links
			>
				{list.map((menuItem) => (
					<Menu.Item
						link
						href={menuItem.href}
						onClick={(e) => {
							this.pushGAEvent(menuItem.gaEventName);
							if (menuItem.onClick) {
								menuItem.onClick(e);
							}
							if(menuItem.callFunction)
							{
								callHeaderfunction(menuItem.callFunction);
							}
						}}
					>
						{menuItem.title}
					</Menu.Item>
				))}
			</Menu>
		);
	}
}

class MyAccountMenu extends Component{
	render(props, state, context){
		const { isLoggedIn , loggedInMenu = defaultLoggedInMenuArr , loggedOutMenu = defaultLoggedOutMenuArr, callHeaderfunction } = props;
		return (
			<span>
				<a href="javascript:void(0);"
					class="mdc-toolbar__icon"
					onClick={e => {
						this.menu.MDComponent.open = true;
					}}
				>
					<Account class="mdc-toolbar__icons" />
					<span class="link-text-hidden">Quikr Account Menu</span>
				</a>
				
				{ !isLoggedIn && <QMenu
					refFn={menu => {
						this.menu = menu;
					}}
					list={loggedOutMenu}
					callHeaderfunction = {callHeaderfunction}
				/>
				}

				{ isLoggedIn && <QMenu
					refFn={menu => {
						this.menu = menu;
					}}
					list={loggedInMenu}
					callHeaderfunction = {callHeaderfunction}
				/>
				}

			</span>
		);
	}
}
export default MyAccountMenu;


// WEBPACK FOOTER //
// ../q-components/components/myAccount/index.js